module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_is-object.js
// module id = Ujg4
// module chunks = 11